// extracted by mini-css-extract-plugin
module.exports = {"badge":"About-module--badge--1sL2N","badgewrap":"About-module--badgewrap--3A5EF"};